export default __webpack_public_path__ + "static/lime-2b60e0b85a88c83d3ba2dd755a3a0aad.gif";